import team1 from "../assets/team1.jpg";
import team2 from "../assets/team2.jpg";
import team3 from "../assets/team3.jpg";
import team4 from "../assets/team4.jpg";
import team5 from "../assets/team5.jpg";
import team6 from "../assets/team6.jpg";

const programData = [
  {
    id: "u17",
    title: "program.u17.title",
    image: team1,
    highlighter: "U17",
    age: "program.u17.age",
    grade: "program.u17.grade",
    desc: "program.u17.desc",
    otherCost: "program.u17.otherCost",
    admision: "program.u17.admision",
    address: "program.u17.address"
  },
  {
    id: "u16",
    title: "program.u16.title",
    image: team2,
    highlighter: "U16",
    age: "program.u16.age",
    grade: "program.u16.grade",
    desc: "program.u16.desc",
    otherCost: "program.u16.otherCost",
    admision: "program.u16.admision",
    address: "program.u16.address"
  },
  {
    id: "u15",
    title: "program.u15.title",
    image: team3,
    highlighter: "U15",
    age: "program.u15.age",
    grade: "program.u15.grade",
    desc: "program.u15.desc",
    otherCost: "program.u15.otherCost",
    admision: "program.u15.admision",
    address: "program.u15.address"
  },
  {
    id: "u14",
    title: "program.u14.title",
    image: team4,
    highlighter: "U14",
    age: "program.u14.age",
    grade: "program.u14.grade",
    desc: "program.u14.desc",
    otherCost: "program.u14.otherCost",
    admision: "program.u14.admision",
    address: "program.u14.address"
  },
  {
    id: "u13",
    title: "program.u13.title",
    image: team5,
    highlighter: "U13",
    age: "program.u13.age",
    grade: "program.u13.grade",
    desc: "program.u13.desc",
    otherCost: "program.u13.otherCost",
    admision: "program.u13.admision",
    address: "program.u13.address"
  },
  {
    id: "dev",
    title:"program.dev.title",
    image: team6,
    highlighter: "DEV",
    age: "program.dev.age",
    grade: "program.dev.grade",
    desc: "program.dev.desc",
    otherCost: "program.dev.otherCost",
    admision: "program.dev.admision",
    address: "program.dev.address"
  },
];

export default programData;
